var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            "action-collapse": "",
            "show-loading": _vm.fetching || _vm.saving,
            title: "Parâmetros do Sistema",
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "mb-1" },
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      type: "text",
                      name: "search",
                      placeholder: _vm.$t(
                        "Pesquisar por Nome, Chave ou Descrição..."
                      ),
                    },
                    on: { input: _vm.onSearchChange },
                    model: {
                      value: _vm.searchTerm,
                      callback: function ($$v) {
                        _vm.searchTerm = $$v
                      },
                      expression: "searchTerm",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.groupedParameters.groups.length > 0
            ? _c(
                "b-tabs",
                {
                  attrs: {
                    "active-tab-index": _vm.getTabIndex(),
                    "nav-wrapper-class": "mb-3",
                  },
                  on: { input: _vm.onTabChange },
                },
                _vm._l(_vm.groupedParameters.groups, function (group) {
                  return _c(
                    "b-tab",
                    {
                      key: group,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("span", { staticClass: "mr-2" }, [
                                  _vm._v(_vm._s(group)),
                                ]),
                                _vm.searchTerm
                                  ? _c(
                                      "b-badge",
                                      { attrs: { variant: "primary" } },
                                      [_vm._v(_vm._s(_vm.getGroupCount(group)))]
                                    )
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm.filteredParameters.length > 0
                        ? _c(
                            "div",
                            { staticClass: "mt-3" },
                            [
                              _c("parameter-list", {
                                attrs: {
                                  parameters: _vm.filteredParameters,
                                  fetching: _vm.fetching || _vm.saving,
                                },
                                on: { edit: _vm.editParameter },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "text-center text-muted py-5" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.searchTerm
                                      ? _vm.$t(
                                          "Nenhum parâmetro encontrado com o critério de pesquisa"
                                        )
                                      : _vm.$t("Nenhum parâmetro disponível")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                    ]
                  )
                }),
                1
              )
            : _c("div", { staticClass: "text-center text-muted py-5" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("Nenhum parâmetro disponível")) + " "
                ),
              ]),
        ],
        1
      ),
      _c("parameter-edit-modal", {
        ref: "editModal",
        on: { saved: _vm.loadParameters },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }